import { Component } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { AppSettings } from '../../shared/app-settings';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'order-confirm',
    templateUrl: 'order-confirm.html',
    styleUrls: ['order-confirm.scss'],
    standalone: false
})
export class OrderConfirmComponent {

    order: any;
    VolumeToStandardTruck: boolean = AppSettings.VolumeToStandardTruck;

    constructor(public navParams: NavParams, public modalCtrl: ModalController, public translateService: TranslateService) {
        this.order = this.navParams.data;
    }

    dismiss(flag) {
        this.modalCtrl.dismiss(flag);
    }
}
